export default __webpack_public_path__ + "static/media/banner_silver.e4047bfe.png";